import { REPORT_LIST_REQUESTING, GENERATING_REPORT_REQUESTING } from './types';

const reportListRequesting = (payload) => ({
	type: REPORT_LIST_REQUESTING,
	payload,
});

const generateTransactionReport = (payload) => ({
	type: GENERATING_REPORT_REQUESTING,
	payload,
});

export { reportListRequesting, generateTransactionReport };
